<!--物流跟踪详情-->
<template>
<el-dialog :title="msg('物流查询')" :close-on-click-modal="false" 
    :visible.sync="visible" width="45%"
    :fullscreen="isMinScreen"
    append-to-body
>
    <div v-if="data" class="ctrl-panel">
        <h3>{{fmt('单号：%s'+"物流跟踪详情", [data.code])}}</h3>
        <div class="trace-wrap">
            <div class="trace-box">
                <h4>{{msg('货物操作记录')}}</h4>
                <el-timeline >
                    <el-timeline-item
                        type="danger"
                        v-for="(item, index) in data.statuses" :key="index"
                        :timestamp="item.created">
                            {{item.createrName}} : {{item.ctrl}} - {{item.label}}-{{item.remark}}
                    </el-timeline-item>
                    <el-link type="danger" v-if="showMoreBtn" @click="showMore()">显示更多</el-link>
                </el-timeline>
            </div>
            <div>
                <h4>{{msg("物流跟踪记录")}}</h4>
                <el-timeline >
                    <el-timeline-item
                        type="danger"
                        v-for="(item, index) in data.twExpTracks" :key="index"
                        :timestamp="item.created">
                            {{item.remark}}
                    </el-timeline-item>
                </el-timeline>
            </div>

        </div>
        <h4>{{msg('国内物流详情')}}</h4>
        <div class="details">
            <!--
            <div class="detail">
                <span>{{data.code}}</span>
                <a target="_blank" :href="'https://www.baidu.com/s?wd='+data.code">{{msg("点击查看物流")}}</a>
            </div>
            -->
            <span v-for="(item, idx) in data.details" :key="idx">
                <div class="detail" v-if="item.innerExpCode">
                    <span>{{item.innerExpCode}}</span>
                    <a target="_blank" :href="'https://www.baidu.com/s?wd='+item.innerExpCode">{{msg("点击查看物流")}}</a>
                </div>
            </span>
        </div>
    </div>
</el-dialog>
</template>

<script>
export default {
    name: 'StockTrace',
    comments: {

    },
    mounted: function(){

    },
    data(){
        return{
            stockId: null,
            data: null,
            visible: false,
            showMoreBtn: false,
        }
    },
    computed: {
        isMinScreen: {  //是否小屏幕，浏览器
            get() {
                var is = this.$store.state.isMinScreen;
                return is;
            }
        },
    },
    methods: {
        showTracks(stockId, hist, type=0){
            this.visible=true;
            this.stockId = stockId;
            this.data = null;
            this.$axios.post(this.$kit.api.stock.traces+"?id="+stockId+"&hist="+hist+"&type="+type)
                .then((result) => {
                    if(result.status){
                        this.data = result.data;
                        this.showMoreBtn = result.data.showMore;
                    }else{
                        this.$message(result.msg || this.msg('获取失败'));
                    }
                });
        },
        showMore(){
            this.showTracks(this.stockId, 0, 1);
        }
    }
}
</script>

<style lang="scss" scoped>
.trace-wrap{display:flex; justify-content: space-between;}
.trace-box{padding: 10px;}
.detail{margin:10px;}
.detail a{display:inline-block; margin-left: 8px;}
</style>